const WHATSAPP_URL = 'https://wa.me/5511986765185?text=Preciso%20de%20um%20or%C3%A7amento.';

const condicoes = [
  {
    icon: 'ri-hand-coin-line',
    value: '10%',
    label: 'de Sinal',
    desc: 'Apenas 10% para reservar sua instalação e travar o orçamento.',
  },
  {
    icon: 'ri-tools-line',
    value: '90%',
    label: 'Após Instalação',
    desc: 'O restante somente após a conclusão e aprovação da instalação.',
  },
  {
    icon: 'ri-bank-card-line',
    value: '10x',
    label: 'Sem Juros',
    desc: 'Parcelamento facilitado em até 10 vezes sem acréscimos.',
  },
];

export default function OfertaEspecial() {
  return (
    <section className="py-16 md:py-24 bg-stone-900 relative overflow-hidden">
      <div className="absolute inset-0 opacity-5">
        <img
          src="https://readdy.ai/api/search-image?query=abstract%20glass%20texture%20pattern%20luxury%20minimal%20background%20dark&width=1920&height=800&seq=bg001&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
        />
      </div>
      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-8 text-center">
        <span className="inline-block bg-amber-500 text-white text-xs font-bold px-4 py-1.5 rounded-full uppercase tracking-widest mb-6">
          OFERTA ESPECIAL LIMITADA
        </span>
        <h2 className="text-3xl md:text-5xl font-bold text-white leading-tight mb-4 max-w-3xl mx-auto">
          RESERVE A SUA INSTALAÇÃO COM O ORÇAMENTO TRAVADO POR 10 MESES
        </h2>
        <p className="text-white/60 text-xs mb-12 max-w-xl mx-auto">
          Garanta hoje o preço atual mesmo que a instalação seja feita meses depois. Condições exclusivas para quem reservar agora.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mb-12">
          {condicoes.map((c) => (
            <div key={c.label} className="bg-white/5 border border-amber-500/30 rounded-2xl p-7 text-center">
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-amber-500/20 text-amber-400 mx-auto mb-4">
                <i className={`${c.icon} text-2xl`}></i>
              </div>
              <p className="text-4xl font-bold text-amber-400 mb-1">{c.value}</p>
              <p className="text-white font-semibold text-xs mb-2">{c.label}</p>
              <p className="text-white/55 text-xs leading-relaxed">{c.desc}</p>
            </div>
          ))}
        </div>

        <a
          href={WHATSAPP_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-3 bg-green-500 hover:bg-green-600 text-white font-bold px-10 py-4 rounded-full text-base md:text-lg transition-all duration-200 whitespace-nowrap hover:scale-105 cursor-pointer"
        >
          <div className="w-6 h-6 flex items-center justify-center">
            <i className="ri-whatsapp-line text-xl"></i>
          </div>
          GARANTIR MINHA RESERVA AGORA
        </a>
        <p className="text-white/40 text-xs mt-4">Vagas limitadas. Consulte disponibilidade.</p>
      </div>
    </section>
  );
}
